<template>
  <div id="app">

    <nav class="navbar navbar-expand-lg navbar-light bg-orange mb-4">

      <a v-if="show_nav" @click="$router.go(-1)">
        <img alt="Trackd logo" src="./assets/icons/back.png" width="30" >
      </a>

      <p class="navbar-brand ml-3 text-light font-weight-light mx-auto text-center mb-0">ChipIn&trade; Account Manager</p>

    </nav>

    <router-view></router-view>

  </div>
</template>

<script>


export default {
  name: 'App',
  computed: {
    show_nav: function () {

      if (this.$route.name === 'auth-refresh' || this.$route.name === 'auth' || this.$route.name === 'auth-error' || this.$route.name === 'details' || this.$route.name === 'register' || this.$route.name === 'guest-auth' || this.$route.name === 'auth-guest-2') {
          return false
      } else {
        return true
      }
      
    }
  }
}
</script>

<style>
  .bg-orange {
    background-color: #F2B471 !important;
  }
  .menu-light {
    color: #9B9B9B !important;
  }
  .menu-dark {
    color: #4A4A4A !important;
  }

 .table thead th {
   font-weight: 400;
   color: #4A4A4A !important;
 }

</style>
